import { connect } from 'react-redux';
import { setCurrency } from 'src/store/Dashboard/actions';
import { logoutThunk } from 'src/store/Auth/actions';
import { default as HeaderRoot } from './Header';

const mapStateToProps = ({ dashboard }) => ({
  search: dashboard.search,
  user: dashboard.user,
  currency: dashboard.currency,
  cachedTop10MarketCountryWise: dashboard.cachedTop10MarketCountryWise,
});

export const Header = connect(mapStateToProps, {
  logoutThunk,
  setCurrency,  
})(HeaderRoot);
